export const UPDATE_PLACE_OTA_CREDENTIALS = 'UPDATE_PLACE_OTA_CREDENTIALS';
export const UPDATE_PLACE_OTA_CREDENTIALS_SUCCESS = 'UPDATE_PLACE_OTA_CREDENTIALS_SUCCESS';
export const UPDATE_PLACE_OTA_CREDENTIALS_FAILED = 'UPDATE_PLACE_OTA_CREDENTIALS_FAILED';
